<template>
  <div class="mesas-page container-fluid mt-4">
    <div class="funcionalidad-container shadow-sm p-3 bg-white rounded">
      <!-- Título principal -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="mb-0">
          <font-awesome-icon icon="table" class="me-2" /> Mesas de la Sala
        </h2>
        <button @click="abrirModal('crear')" class="btn btn-sm btn-outline-success">
          <font-awesome-icon icon="fas fa-plus" class="me-1" /> Crear Mesa
        </button>
      </div>

      <div class="row">
        <div v-for="mesa in mesas" :key="mesa.id" class="col-md-4 mb-3">
          <div class="card h-100 shadow-sm">
            <div class="card-body">
              <h5 class="card-title">{{ mesa.nombre }}</h5>
              <p class="card-text">
                <strong>Sala:</strong> {{ mesa.salaDeCultivo.nombre }}
              </p>
              <p class="card-text">
                <strong>Largo:</strong> {{ mesa.largo }} metros
              </p>
              <p class="card-text">
                <strong>Ancho:</strong> {{ mesa.ancho }} metros
              </p>
              <p class="card-text">
                <strong>Descripción:</strong> {{ mesa.descripcion || 'N/A' }}
              </p>
            </div>
            <div class="card-footer d-flex justify-content-between">
              <button @click="abrirModal('editar', mesa)" class="btn btn-sm btn-outline-primary">
                <font-awesome-icon icon="fas fa-edit" class="me-1" /> Editar
              </button>
              <button @click="eliminarMesa(mesa.id)" class="btn btn-sm btn-outline-danger">
                <font-awesome-icon icon="fas fa-trash-alt" class="me-1" /> Borrar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal para crear o editar una mesa -->
      <div v-if="modalActivo" class="modal fade show d-block" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ modalModo === 'crear' ? 'Crear Mesa' : 'Editar Mesa' }}</h5>
              <button type="button" class="btn-close" @click="cerrarModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="guardarMesa">
                <div class="mb-3">
                  <label for="nombre" class="form-label">Nombre</label>
                  <input v-model="mesaEnEdicion.nombre" type="text" class="form-control" id="nombre" required />
                </div>
                <div class="mb-3">
                  <label for="largo" class="form-label">Largo (metros)</label>
                  <input v-model="mesaEnEdicion.largo" type="number" class="form-control" id="largo" required />
                </div>
                <div class="mb-3">
                  <label for="ancho" class="form-label">Ancho (metros)</label>
                  <input v-model="mesaEnEdicion.ancho" type="number" class="form-control" id="ancho" required />
                </div>
                <div class="mb-3">
                  <label for="descripcion" class="form-label">Descripción</label>
                  <textarea v-model="mesaEnEdicion.descripcion" class="form-control" id="descripcion"></textarea>
                </div>
                <button type="submit" class="btn btn-primary">{{ modalModo === 'crear' ? 'Crear' : 'Guardar' }}</button>
                <button type="button" class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  props: {
    club_id: {
      type: Number,
      required: true,
    },
    salaDeCultivoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      mesas: [],
      mesaEnEdicion: null, // Mesa que se está creando o editando
      modalActivo: false, // Indica si el modal está abierto
      modalModo: 'crear', // 'crear' o 'editar'
      clubActual: this.$store.getters.getClubActual,
    };
  },
  watch: {
    salaDeCultivoId: {
      immediate: true,
      handler(nuevoId) {
        this.obtenerMesasDeCultivo(nuevoId); // Recargar mesas al cambiar salaDeCultivoId
      },
    },
  },
  methods: {
    async obtenerMesasDeCultivo(salaId) {
      try {
        const response = await axios.get(`/api/salasDeCultivo/${salaId}/mesasDeCultivo`);
        this.mesas = response.data;
      } catch (error) {
        console.error('Error al obtener la lista de mesas de cultivo:', error);
      }
    },
    abrirModal(modo, mesa = null) {
      this.modalModo = modo;
      this.mesaEnEdicion = mesa
        ? { ...mesa }
        : { nombre: '', largo: 0, ancho: 0, descripcion: '', sala_id: this.salaDeCultivoId };
      this.modalActivo = true;
    },
    async guardarMesa() {
      try {
        if (this.modalModo === 'crear') {
          await axios.post(`/api/mesasDeCultivo`, {form: this.mesaEnEdicion, club_id: this.club_id});
          alert('Mesa creada con éxito');
        } else {
          await axios.put(`/api/mesasDeCultivo/${this.mesaEnEdicion.id}`, {form: this.mesaEnEdicion, club_id: this.club_id});
          alert('Mesa actualizada con éxito');
        }
        this.cerrarModal();
        this.obtenerMesasDeCultivo(this.salaDeCultivoId); // Recargar la lista
      } catch (error) {
        console.error('Error al guardar la mesa:', error);
      }
    },
    cerrarModal() {
      this.modalActivo = false;
      this.mesaEnEdicion = null;
    },
    async eliminarMesa(id) {
      if (confirm('¿Estás seguro de que deseas eliminar esta mesa?')) {
        try {
          await axios.delete(`/api/mesasDeCultivo/${id}`, {data: {club_id: this.club_id}});
          alert('Mesa eliminada con éxito');
          this.obtenerMesasDeCultivo(this.salaDeCultivoId);
        } catch (error) {
          console.error('Error al eliminar la mesa:', error);
        }
      }
    },
  },
};
</script>

<style scoped>
.mesas-page {
  padding: 20px;
  background-color: #f7f8fa;
}

h2 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
}

.card {
  border-radius: 8px;
  border: 1px solid #e5e5e5;
}

.card-body {
  padding: 15px;
}

.card-footer {
  background-color: #f8f9fa;
  border-top: none;
  padding: 10px 15px;
}

.btn-sm {
  font-size: 0.85rem;
  padding: 6px 12px;
}

.shadow-sm {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  border-radius: 8px;
}
</style>
